import React from 'react'
import logo from "../assets/img/logo.svg"

const NavBar = () => {
  return (
    <nav className="hero__nav container">
        <figure className="hero__logo">
            <img src={logo} alt="Logo de la página" className="hero__huddle" />
        </figure>
        <a href="www.google.com" className="hero__cta">Try it free</a>
    </nav>
  )
}

export default NavBar